import PropTypes from 'prop-types';

const gameType = PropTypes.exact({
  averageDuration: PropTypes.number.isRequired,
  overallAccuracy: PropTypes.number.isRequired,
  timesPlayed: PropTypes.number.isRequired,
  games: PropTypes.arrayOf(PropTypes.object).isRequired,
});

const gameResultsAttributesType = PropTypes.shape({
  deception: gameType,
  encryption: gameType,
  surveillance: gameType,
  specialOps: gameType,
  hotRisk: gameType,
  mentalHorsepower: gameType,
  psychometrics: gameType,
});

export default gameResultsAttributesType;
